<template lang="pug">
	.projects-plane(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id" :class="Layout.page" :style="{height: `calc(100% - ${Layout.subHeaderHeight}px)`, top: `${Layout.subHeaderHeight}px`}")
		.projects-plane-inner(ref="scrollElement")
			.project.add(v-if="Layout.page === 'banners' || Layout.page === 'end-cards' || (Layout.page === 'playables' && Metadata.Config['feature-playable-templates'])")
				.project-add-icon(v-on:click="addProject()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Create project'}")
					i.fa.fa-plus
			.project(v-for="project in projects" :key="project.id" @mouseover="onProjectOver(project, $event)" @mouseout="onProjectOut(project, $event)")
				.project-icon(:class="getProjectIconClasses(project)" :style="getProjectIconStyles(project)" v-on:click="Project.selectProject(project.id)")
				.project-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-project-plane')")
					OnlineUsersLocal(:filter="getFilterForOnlineUsers(project.id)" max-count="3")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { User } from './../../services/User'
	import { Project } from './../../services/Project'
	import { Layout } from './../../services/Layout'

	import OnlineUsersLocal		from './../../components/Header/OnlineUsersLocal';

	import SetupSettings from "./../../settings/settings.json";

	export default {
		name: 'ProjectsPlane',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Current User Changed", "Project Changed", "Selected Project Changed", "Projects Icons Changed", "Selected Publisher Changed",
				"Project Fully Loaded", "Projects Filter Changed", "Current User Feature Changed", "Users Online Status Changed", "User Online Status Changed", "User Online Status Added",
				"User Online Status Removed", "Layout Page Showed:banners", "Layout Page Showed:playables", "Layout Page Showed:end-cards", "Layout Page Showed:marker", "Selected Project Tags Changed",
				"Selected Project Icon Changed", "Project Icon Changed"],
			events: {

			}
		},
		components: {
			OnlineUsersLocal
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;
			this.Project = Project;
			this.SetupSettings = SetupSettings;

			this.projects = [];

			return {
				showed: true
			};
		},
		methods: {
			collectData() {

				this.projects = Project.getOrderedProjectsList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.projectsFilter);

				if (this.$refs.scrollElement) {

					this.$refs.scrollElement.removeEventListener('scroll', this.dispatchScrollEvent);
					this.$refs.scrollElement.addEventListener('scroll', this.dispatchScrollEvent);

				}

			},
			getProjectIconClasses(project) {

				let classes = {
					selected: Project.SelectedProject?.id === project.id
				};


				if (Layout.page === 'playables') {

					classes.hidden = project.Tags['hidden'];
					classes.dev = !project.Tags['released'];

				}

				return classes;

			},
			getProjectIconStyles(project) {

				if (project.options.iconUrl) {

					return {
						backgroundImage: `url(${project.options.iconUrl}` + (Project.ProjectsIconsTimes[project.id] ? '?v=' + Project.ProjectsIconsTimes[project.id] : '') + ')'
					};

				} else if (project.type === 'playable') {

					if (project.templateProps) {

						return {
							backgroundImage: `url(/Images/Icons/Playables/${project.templateProps.codename.replace(':', '-')}.png` + (Project.ProjectsIconsTimes[project.id] ? '?v=' + Project.ProjectsIconsTimes[project.id] : '') + ')'
						};

					} else {

						return {
							backgroundImage: `url(/Images/Icons/Projects/${project.codename}.png` + (Project.ProjectsIconsTimes[project.id] ? '?v=' + Project.ProjectsIconsTimes[project.id] : '') + ')'
						};

					}

				} else if (project.type === 'banner') {

					return {
						backgroundImage: `url(/Images/Icons/Banners/${project.templateProps.codename}.png)`
					};

				} else if (Layout.page === 'end-cards') {

					return {
						backgroundImage: `url(/Images/Icons/EndCards/${project.templateProps.codename}.png)`
					};

				}

			},
			getFilterForOnlineUsers(projectId) {

				return userData => User.getLastActiveVersionData(userData).projectId === projectId;

			},
			addProject() {

				if (Layout.page === 'playables') Broadcast.call("Show ProjectCreatePlayable");
				else if (Layout.page === 'banners') Broadcast.call("Show ProjectCreateBanner");
				else if (Layout.page === 'end-cards') Broadcast.call("Show ProjectCreateEndCard");

			},
			onProjectOver(project, e) {

				let el = e.currentTarget;

				Broadcast.call("Show Project Preview", [project, e, el]);

			},
			onProjectOut(project, e, el) {

				Broadcast.call("Hide Project Preview", [project, e, el]);

			},
			dispatchScrollEvent() {

				Broadcast.call("Projects Plane Scroll");

			}
		}
	}
</script>

<style lang="sass">

	.projects-plane
		width: 60px
		height: 100%
		text-align: center
		background-color: #343b41
		border-right: 1px solid #23282c
		position: absolute
		left: 0
		top: 0
		overflow: hidden
		z-index: 1

		.projects-plane-inner
			overflow-y: auto
			width: 100px
			height: 100%

		.project
			width: 58px
			height: 84px
			display: flex
			align-items: center
			justify-content: center
			position: relative

			.project-icon
				background: center / 100% no-repeat
				width: 50px
				height: 76px
				border-radius: 5px
				cursor: pointer
				border: 2px solid transparent
				image-rendering: -webkit-optimize-contrast

				&.selected
					border: 2px solid cornsilk
					border-radius: 3px

				&.dev
					opacity: 0.9

				&.hidden
					opacity: 0.1

			.project-online
				display: flex
				position: absolute
				left: 5px
				width: 48px
				bottom: -3px
				height: 20px
				pointer-events: none

				.online-users-local
					flex-direction: row-reverse

					.user-content
						max-width: 15px

						.user-photo
							border: 1px solid rgba(255, 255, 255, 0.5)
							left: auto
							right: 0

							.c-avatar-status
								display: none

						.additional-users-count
							padding-top: 1px
		.project.add
			height: 50px

			.project-add-icon
				color: #f3f4f5
				width: 40px
				height: 30px
				font-size: 20px
				cursor: pointer
				margin-left: 2px

				&:hover
					color: #20a8d8

</style>

